import React from "react";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {AppBar, Divider, Link, Toolbar} from "@material-ui/core";
import {DESKTOP_IMPRINT_LINKS, DESKTOP_TERMS_AND_CONDITIONS_LINKS} from "../../constants/Links";
import {getDomain} from "../../api/BackendRestClient";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        appBar: {
            top: 'auto',
            bottom: 0,
            color: "#fff",
            backgroundColor: theme.palette.primary.main,
            "& .MuiToolbar-root": {
                minHeight: 0,
                // padding: 5
            },
            "& .MuiTypography-root": {
                color: "#fff",
                cursor: "pointer"
            },
            "& .MuiDivider-root": {
                height: 15,
                margin: 4,
                backgroundColor: "#fff",
                marginRight: 10,
                marginLeft: 10
            }
        },
    }),
);


const PageFooter: React.FC<any> = () => {

    const {t} = useTranslation();
    const classes = useStyles();

    const render = (<AppBar position="fixed" className={classes.appBar} id={"footer-bar"}>
        <Toolbar variant="dense">
            <Link href={DESKTOP_TERMS_AND_CONDITIONS_LINKS[getDomain()]}>{t("buttons.terms-and-conditions")}</Link>
            <Divider orientation="vertical" variant="middle"/>
            <Link href={DESKTOP_IMPRINT_LINKS[getDomain()]}>{t("buttons.imprint")}</Link>
        </Toolbar>
    </AppBar>);

    return render;
};

export default PageFooter;
